// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3L-DA","insightsList":"newBusinessInsightsMenu_insightsList__2B7u5","active":"newBusinessInsightsMenu_active__2vUNc"};